export default __webpack_public_path__ + "static/media/notepad.bab08501.svg";